export const createEditorHistory = () => ({
  undo: [],
  redo: [],
  current: null,
  lastRecord: null
});

export const resetEditorHistory = (history, current = null) => {
  history.undo = [];
  history.redo = [];
  history.current = current;
  history.lastRecord = null;
};

export const recordEditorHistory = (
  history,
  html,
  { kind = 'command', coalesce = false, timestamp = Date.now(), limit = 50 } = {}
) => {
  const canCoalesce = coalesce
    && history.lastRecord?.kind === kind
    && timestamp - history.lastRecord.timestamp < 750;

  if (!canCoalesce && history.undo[history.undo.length - 1] !== html) {
    history.undo.push(html);
    if (history.undo.length > limit) history.undo.shift();
  }

  history.redo = [];
  history.current = html;
  history.lastRecord = { kind, timestamp };
};

const restore = (history, currentHtml, sourceKey, destinationKey) => {
  const source = history[sourceKey];
  const destination = history[destinationKey];
  if (!source.length) return null;

  const snapshot = source.pop();
  if (destination[destination.length - 1] !== currentHtml) destination.push(currentHtml);
  history.current = snapshot;
  history.lastRecord = null;
  return snapshot;
};

export const undoEditorHistory = (history, currentHtml) => restore(history, currentHtml, 'undo', 'redo');

export const redoEditorHistory = (history, currentHtml) => restore(history, currentHtml, 'redo', 'undo');
